import { render, staticRenderFns } from "./text-field-primary.vue?vue&type=template&id=0dccc16a&scoped=true&"
import script from "./text-field-primary.vue?vue&type=script&lang=js&"
export * from "./text-field-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dccc16a",
  null
  
)

export default component.exports